import { ColumnsType } from "antd/lib/table";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router";
import { fetchReviewList } from "../../apis/Review/apis";
import { ReviewQueryParams } from "../../apis/Review/apis/types";
import { NumberArray } from "../../components/constants";
import PaginationFilterTable from "../../components/molecures/PaginationFilterTable";
import { ReviewRate } from "../../components/molecures/ReviewRate";
import { TableFilterFormElementType } from "../../components/molecures/TableFilter/enums";
import { TableFilterForm } from "../../components/molecures/TableFilter/interfaces";
import useShop from "../../hooks/useShop";
import useUser from "../../hooks/useUsers";
import { RepairShopReview } from "../../model/RepairShopReivew";
import { ReviewItem } from "../../model/ReviewItem";
import { alertError } from "../../shared/utils";
import { getDecodeToken } from "../../shared/utils/Token";

/**
 * @description 마스터계정이 추가되면서 마스터, 일반 계정에 대한 컬럼이 달라짐 (장착점명, 장착점코드)
 * @description 테이블의 내부 로직은 정상적으로 반응하나, 고정된 구조 상 페이징 속성이 꼬여있음 (pagination { page, pageSize})
 * @description 테이블 페이지 컴포넌트 쪼갤 필요 있음 (230228)
 * @returns
 */
const ReviewManangement: React.FC = () => {
  const { getAdminInfo, getUserID } = useUser();
  const nav = useNavigate();
  const location = useLocation();
  const { shop } = useShop();

  const initialValues = {
    repairShopId: getAdminInfo()?.id || -1,
  };
  const [filterItems, setFilterItems] = useState<ReviewQueryParams>({
    ...initialValues,
    page: 1,
    pageSize: 10,
  });

  const master = useMemo(() => {
    const info = getDecodeToken();

    return info?.isMaster && +shop === getUserID();
  }, [shop]);

  const { data, refetch, isFetching, isLoading } = useQuery(
    "review",
    () => fetchReviewList({ ...filterItems }),
    {
      enabled: false,
      onError: (error: any) => {
        if (error.status !== 404) {
          alertError(error.message);
        }
      },
    }
  );

  const filterForms: TableFilterForm[] = [
    {
      label: "등록일",
      type: TableFilterFormElementType.DateRangePicker,
      key: "createdAtRange",
      dateRangeKeys: ["createdAtFrom", "createdAtTo"],
    },

    {
      label: "평점",
      type: TableFilterFormElementType.Select,
      options: NumberArray(5).map((val) => ({
        label: val.value,
        value: val.value,
      })),
      key: "minScore",
    },
  ];

  const masterColumns: ColumnsType<RepairShopReview> = [
    {
      title: "등록일",
      width: "10%",
      dataIndex: "createdAt",
      render: (value) =>
        value ? moment(value).subtract(9, "h").format("YYYY-MM-DD") : "-",
    },

    {
      title: "매장명",
      width: "15%",
      dataIndex: "displayName",
      render: (value, record) => record.repairShop?.displayName,
    },

    {
      title: "매장코드",
      width: "15%",
      dataIndex: "repairShopCode",
      align: "center",
      render: (value, record) => record.repairShop?.repairShopCode,
    },

    {
      title: "리뷰내용",
      width: 448,
      dataIndex: "reviewItem",
      render: (value: ReviewItem) => {
        return value?.review?.reviewContent;
      },
    },
    {
      title: "평점",
      width: 144,
      dataIndex: "reviewItem",
      render: (value: ReviewItem) => <ReviewRate value={value.reviewScore} />,
    },
  ];

  const columns: ColumnsType<RepairShopReview> = [
    {
      title: "등록일",
      width: 152,
      dataIndex: "createdAt",
      render: (value) =>
        value ? moment(value).subtract(9, "h").format("YYYY-MM-DD") : "-",
    },

    {
      title: "리뷰내용",
      width: 448,
      dataIndex: "reviewItem",
      render: (value: ReviewItem) => {
        return value?.review?.reviewContent;
      },
    },
    {
      title: "평점",
      width: 144,
      dataIndex: "reviewItem",
      render: (value: ReviewItem) => <ReviewRate value={value.reviewScore} />,
    },
  ];

  const fetchFuctionasync = async (
    page: number,
    pageSize: number,
    queryParams: ReviewQueryParams
  ) => {
    const repairShopId = +shop || getUserID();
    setFilterItems({
      ...queryParams,
      page,
      pageSize,
      repairShopId,
    });
  };

  useEffect(() => {
    if (shop) {
      setFilterItems({
        ...initialValues,
        page: 1,
        pageSize: 10,
      });
    }
  }, [shop]);

  useEffect(() => {
    if (filterItems) {
      refetch();
    }
  }, [filterItems]);

  return (
    <PaginationFilterTable
      verticalAlign="middle"
      headerTitle="리뷰 리스트"
      dataSource={data?.rows}
      columns={master ? masterColumns : columns}
      initialFilterValues={initialValues}
      totalCount={data?.count}
      loading={isFetching || isLoading}
      onRow={(record) => {
        return {
          onClick: () => {
            nav(`/review-manangement/${record.id}${location.search}`);
          },
        };
      }}
      fetchAction={fetchFuctionasync}
      filterForms={filterForms}
    />
  );
};
export default ReviewManangement;
